import { IEnvironment } from '../app/core/interfaces';

export const environment: IEnvironment = {
  version: '1.2.5',
  production: true,
  classic: true,
  apiUrl: 'https://proflyt-api-internal-classic.proflytnexus.com',
  clientUrl: 'https://classic.proflytnexus.com',
  firebaseConfig: {
    apiKey: 'AIzaSyDodeP_q-rkLSRtPN7lIHrDb5m2Rr9l0B0',
    authDomain: 'proflyt.firebaseapp.com',
    databaseURL: 'https://proflyt.firebaseio.com',
    projectId: 'proflyt',
    storageBucket: 'proflyt.appspot.com',
    messagingSenderId: '853525073122',
    appId: '1:853525073122:web:eebd9909a52b1591d922bb',
    measurementId: 'G-286E18VW9Z',
  },
  appIdentifier: 'com.ProFlyt.ProFlyt',
  iosAppId: '1548088693',
  apiBaseUrl: 'https://proflyt-api-internal-classic.proflytnexus.com',
  itsScrappingUrl: 'https://its-ms-classic.proflytnexus.com',
  itsScrappingToken: 'BwdeTOymZbXPxPKFoxMieZSye5nDWsRo',
  authProvider: 'rest',
  keycloakConfig: {
    realm: 'Classic',
    clientId: 'api-proflyt',
    url: 'https://ricardo-testbed.didmy.best', // Keycloak URL from ingress
  },

  // METREA DEMO CONFIG
  metreaDemo: {
    squadronName: 'Metrea',
  },
};
